import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import warning from "../../assets/icons/warning.png";

class PasswordConfirmationModal extends Component {
    constructor(props) {
        super();

        this.state = {
            password: ""
        }
    }
    render() {
        const { password } = this.state;
        const { open, close } = this.props;

        let warningError = (

			<img src={warning} alt="warning" width="14px" height="14px" style={{ marginRight: "6px" }} />

        );
        
        return (
            <Modal
                centered
                show={open}
                onHide={close}
                bsSize="small"
                className="password-confirmation-modal"
            >
                <Modal.Header className="header">
                    <Modal.Title className="title">Confirm Password to  Continue</Modal.Title>
                    <button
                        onClick={close}
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        className="close"
                    >
                        <span className="x">x</span>
                    </button>

                </Modal.Header>
                <Modal.Body className="body">
                    <input
						type="password"
						name="password"
						value={ password }
						placeholder="Password"
						onChange={ (e) => this.setState({ password: e.target.value }) }
						className={ !password || password !== "12345678" ? "form-control errorInput" : "form-control" }
					/>
                    {
                        !password || password !== "12345678" ? (
                            <div className="error">
                                { warningError }
                                { password && password !== "12345678" ? "Invalid password. Please try again." : "" }
                                { !password ? "Please enter your Askademia password to continue." : "" }
                            </div>
                        ) : ""
                    }
                    <p className="sub-title">
                        For your security, please enter your  Askademia password  to  continue.
                        <span>Forgot password?</span>
                    </p>
                </Modal.Body>
                <Modal.Footer className="footer">
                    <button className="cancel" onClick={close}>Cancel</button>
                    <button className="confirm" onClick={close}>Confirm Password</button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default PasswordConfirmationModal;